import { preferredSessionsTypes } from 'constants';
import { fields, createSchema, validate as _validate } from '..';
import { string } from 'yup';

const {
  firstName,
  lastName,
  optionalEmail,
  requiredText,
  birthDate,
  requiredBoolean,
  optionalText,
  phoneNumber,
  email,
  shouldBeTrue,
  requiredRadio,
  postcode,
  preferredSessionsType,
} = fields;

const organisationWorkingInPrisonsSchema = createSchema({
  firstName,
  lastName,
  hasDeviceInternetAccess: requiredText,
  involvedBefore: requiredText,
  preReleased: requiredBoolean,
  nomisId: optionalText,
  delius: optionalText,
  probationOfficerName: requiredText,
  probationOfficerEmail: email,
  email: optionalEmail,
  availability: optionalText,
  additionalInfo: requiredText,
  dateOfBirth: birthDate,
  //referrer
  referrerFirstName: requiredText,
  referrerLastName: requiredText,
  referrerEmail: email,
  referrerPhoneNumber: phoneNumber,
  relationship: requiredText,
  acceptPrivacyPolicy: shouldBeTrue,
  confirmedPermissionType: requiredRadio,
});

const organisationDoesNotWorkingInPrisonsSchema = createSchema({
  firstName,
  lastName,
  hasDeviceInternetAccess: requiredText,
  involvedBefore: requiredText,
  preferredSessionsType,
  postcode: string().when('preferredSessionsType', {
    is: preferredSessionsTypes.ONLINE,
    then: string().notRequired(),
    otherwise: postcode,
  }),
  email: optionalEmail,
  availability: optionalText,
  additionalInfo: requiredText,
  dateOfBirth: birthDate,
  //referrer
  referrerFirstName: requiredText,
  referrerLastName: requiredText,
  referrerEmail: email,
  referrerPhoneNumber: phoneNumber,
  relationship: requiredText,
  acceptPrivacyPolicy: shouldBeTrue,
  confirmedPermissionType: requiredRadio,
});

const validate = (data, isWorkingInPrison) => {
  return _validate(
    isWorkingInPrison
      ? organisationWorkingInPrisonsSchema
      : organisationDoesNotWorkingInPrisonsSchema,
    data
  );
};

export default validate;
